import axios from "axios";
import queryString from 'query-string';
import { APIAddress } from "constants/config";


export default function getCurrentTeacher(opts) {

  if(!opts.schoolId){
    throw 'Missing school ID'
  }

  let query = queryString.stringify({
    amount_per_page: opts.amount_per_page,
    current_page_number: opts.current_page_number,
    keyword: opts.keyword,
    order_by: opts.order_by,
  });

  return new Promise((resolve, reject) => {
    axios.put(APIAddress, {'uri': `/rgst_tch/${opts.schoolId}/?archived=false&${query}`,
    'method': 'GET',
    'token': localStorage.getItem('token')})
    .then((res) => {
      resolve(res.data);
    })
    .catch((err) => {
      reject(err);
    })
  })
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/teacher/getCurrentTeacher.js